<template>
    <div>
        <div class="spinner-border text-white spinner-border-sm ms-3" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

